import { makeT } from "@lana-commerce/core/react/translateLocalStatic";

// prettier-ignore
export const T = makeT({
  ru: {
    "Address Book": "Адресная книга",
    "Log Out": "Выйти",
    "Order History": "История заказов",
    "Payment Info": "Платежная информация",
    Profile: "Учетная запись",
    "Reset Password": "Сброс пароля",
    Returns: "Мои возвраты",
    "Saved Items": "Сохраненные предметы",
    "Store Credit": "Баланс",
    Subscriptions: "Подписки",
  },
});
